// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import Photo from "./photo.js"
import PhotoSheetProductBox from "./photo-sheet-product-box.js"

const modelClassData = {
  "attributes": {
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": true
    },
    "global": {
      "column": {
        "default": false,
        "name": "global",
        "null": false,
        "type": "boolean"
      },
      "name": "global",
      "selected_by_default": null,
      "translated": false
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": true
    },
    "identifier": {
      "column": {
        "default": null,
        "name": "identifier",
        "null": true,
        "type": "string"
      },
      "name": "identifier",
      "selected_by_default": null,
      "translated": false
    },
    "name": {
      "column": null,
      "name": "name",
      "selected_by_default": null,
      "translated": true
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": true
    }
  },
  "className": "PhotoType",
  "collectionKey": "photo_types",
  "collectionName": "photo_types",
  "i18nKey": "photo_type",
  "camelizedLower": "photoType",
  "name": "PhotoType",
  "nameDasherized": "photo-type",
  "pluralName": "photo_types",
  "ransackable_associations": [
    {
      "className": "PhotoType::Translation",
      "collectionName": null,
      "foreignKey": "photo_type_id",
      "name": "current_translation",
      "macro": "has_one",
      "resource_name": null,
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "PhotoPhotoType",
      "collectionName": "photo_photo_types",
      "foreignKey": "photo_type_id",
      "name": "photo_photo_types",
      "macro": "has_many",
      "resource_name": "PhotoPhotoType",
      "through": null
    },
    {
      "className": "PhotoSheetProductBox",
      "collectionName": "photo_sheet_product_boxes",
      "foreignKey": "photo_type_id",
      "name": "photo_sheet_product_boxes",
      "macro": "has_many",
      "resource_name": "PhotoSheetProductBox",
      "through": null
    },
    {
      "className": "Photo",
      "collectionName": "photos",
      "foreignKey": "photo_id",
      "name": "photos",
      "macro": "has_many",
      "resource_name": "Photo",
      "through": "photo_photo_types"
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "PhotoType::Translation",
      "collectionName": null,
      "foreignKey": "photo_type_id",
      "name": "translations",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "global",
      "column": {
        "default": false,
        "name": "global",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "identifier",
      "column": {
        "default": null,
        "name": "identifier",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "Photo",
      "collectionName": "photos",
      "foreignKey": "photo_id",
      "name": "photos",
      "macro": "has_many",
      "resource_name": "Photo",
      "through": "photo_photo_types"
    },
    {
      "className": "PhotoSheetProductBox",
      "collectionName": "photo_sheet_product_boxes",
      "foreignKey": "photo_type_id",
      "name": "photo_sheet_product_boxes",
      "macro": "has_many",
      "resource_name": "PhotoSheetProductBox",
      "through": null
    }
  ],
  "paramKey": "photo_type",
  "primaryKey": "id"
}

/** Frontend model for PhotoType. */
export default class PhotoType extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  global() {
    return this.readAttributeUnderscore("global")
  }

  /** @returns {boolean} */
  hasGlobal() {
    const value = this.global()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  identifier() {
    return this.readAttributeUnderscore("identifier")
  }

  /** @returns {boolean} */
  hasIdentifier() {
    const value = this.identifier()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./photo.js").default>} */
  photos() {
    return new Collection(
      {
        reflectionName: "photos",
        model: this,
        modelClass: Photo
      },
      {
        params: {
          through: {
            model: "PhotoType",
            id: this.primaryKey(),
            reflection: "photos"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./photo.js").default>>} */
  loadPhotos() {
    return this._loadHasManyReflection(
      {
        reflectionName: "photos",
        model: this,
        modelClass: Photo
      },
      {
        params: {
          through: {
            model: "PhotoType",
            id: this.primaryKey(),
            reflection: "photos"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./photo.js").default>>} */
  ensurePhotosLoaded() {
    return this.ensureAssociationLoaded("photos")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./photo-sheet-product-box.js").default>} */
  photoSheetProductBoxes() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["photo_type_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "photo_sheet_product_boxes",
        model: this,
        modelClass: PhotoSheetProductBox
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./photo-sheet-product-box.js").default>>} */
  loadPhotoSheetProductBoxes() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["photo_type_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "photo_sheet_product_boxes",
        model: this,
        modelClass: PhotoSheetProductBox
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./photo-sheet-product-box.js").default>>} */
  ensurePhotoSheetProductBoxesLoaded() {
    return this.ensureAssociationLoaded("photo_sheet_product_boxes")
  }
}
